// import React from 'react';
// import { Button, Image, Typography, Card, Row, Col } from 'antd';
// import { StarOutlined, SwapOutlined, EyeOutlined } from '@ant-design/icons';

// // import { products } from 'data/dummydata';
// import { Link } from 'react-router-dom';
// import { useProductsContext } from 'contexts/ProductsContext';
// import { useCartContext } from 'contexts/CartContext';
// import { useWishlistContext } from 'contexts/WishlistContext';

// const { Text, Title } = Typography;

// export default function OurSellers() {
//     // const productsArray = Object.values(products);
//     const { products } = useProductsContext()
//     const { addToCart } = useCartContext()
//     const { addToWishlist } = useWishlistContext()

//     const handleAddToCart = async (product) => {
//         await addToCart(product);
//         window.toastify(`${product.name} added to cart`, "success");
//     };

//     const handleAddToWishlist = async (product) => {
//         await addToWishlist(product);
//         window.toastify(`${product.name} added to wishlist`, "success");
//     };
//     return (
//         <section className="bg-light py-5">
//             <div className="container">
//                 <Title level={2} className="pb-5 text-center">Our Bestseller</Title>
//                 <Row gutter={[16, 16]}>
//                     {products.slice(0, 8).map((product, index) => (
//                         <Col xs={24} sm={12} md={8} lg={6} key={index}>
//                             <div className="product-image-container mb-0 pb-0">
//                                 <Image src={product.images[0]} alt={product.name} preview={false} width={"100%"} height={350} />
//                                 <div className="product-overlay">
//                                     <div className="overlay-icons">
//                                         <Button icon={<StarOutlined />} shape="circle" onClick={() => handleAddToWishlist(product)} />
//                                         <Button icon={<SwapOutlined />} shape="circle" />
//                                         <Link to={`/product?category=${encodeURIComponent(product.slug)}`} className=' text-decoration-none'>
//                                             <Button icon={<EyeOutlined />} shape="circle" />
//                                         </Link>
//                                     </div>
//                                     <Button type="primary" className="bg-white text-primary fw-medium add-to-cart-btn mt-3" onClick={() => handleAddToCart(product)}>
//                                         Add To Cart
//                                     </Button>
//                                 </div>
//                             </div>
//                             <Card className="bg-transparent border-0 product-card m-0 p-0">
//                                 <Link to={`/product?category=${encodeURIComponent(product.slug)}`} className=' text-decoration-none'>
//                                     <Text strong className=' fw-bold fs-5'>{product.name}</Text>
//                                 </Link>
//                                 <br />
//                                 <Text strong>{product.description}</Text>
//                                 <div className="pricing mt-2">
//                                     <Text delete className="fs-6">${product.price.toFixed(2)}</Text>
//                                     <Text strong className="text-primary ml-2 ms-3 fs-5">${product.originalPrice.toFixed(2)}</Text>
//                                 </div>
//                             </Card>
//                         </Col>
//                     ))}
//                 </Row>
//             </div>
//         </section>
//     );
// }<ShoppingCartOutlined />

import React from 'react';
import { Button, Image, Typography, Card, Row, Col } from 'antd';
import { StarOutlined, StarFilled, SwapOutlined, EyeOutlined, ShoppingCartOutlined, ShopOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useProductsContext } from 'contexts/ProductsContext';
import { useCartContext } from 'contexts/CartContext';
import { useWishlistContext } from 'contexts/WishlistContext';

const { Text, Title } = Typography;

export default function OurSellers() {
    const { products } = useProductsContext();
    const { addToCart, cartItems } = useCartContext();
    const { addToWishlist, wishlistItems } = useWishlistContext();

    const handleAddToCart = async (product) => {
        await addToCart(product);
        window.toastify(`${product.name} added to cart`, "success");
    };

    const handleAddToWishlist = async (product) => {
        await addToWishlist(product);
        window.toastify(`${product.name} added to wishlist`, "success");
    };

    const isInWishlist = (product) => wishlistItems.some(item => item.id === product.id);
    const isInCart = (product) => cartItems.some(item => item.id === product.id);

    return (
        <section className="bg-light py-5">
            <div className="container">
                <Title level={2} className="pb-5 text-center">Our Bestseller</Title>
                <Row gutter={[16, 16]}>
                    {products.slice(0, 8).map((product, index) => (
                        <Col xs={24} sm={12} md={8} lg={6} key={index}>
                            <div className="product-image-container mb-0 pb-0">
                                <Image src={product.images[0]} alt={product.name} preview={false} width={"100%"} height={350} />
                                <div className="product-overlay">
                                    <div className="overlay-icons">
                                        <Button icon={isInWishlist(product) ? <StarFilled /> : <StarOutlined />} shape="circle" disabled={isInWishlist} onClick={() => handleAddToWishlist(product)} />
                                        <Button icon={<SwapOutlined />} shape="circle" />
                                        <Link to={`/product?category=${encodeURIComponent(product.slug)}`} className='text-decoration-none'>
                                            <Button icon={<EyeOutlined />} shape="circle" />
                                        </Link>
                                    </div>
                                    <Button
                                        type="primary"
                                        className="bg-white text-primary fw-medium add-to-cart-btn mt-3"
                                        onClick={() => handleAddToCart(product)}
                                        disabled={isInCart(product)}
                                        icon={isInCart(product) ? <ShopOutlined /> : <ShoppingCartOutlined />}
                                    >
                                        {isInCart(product) ? 'In Cart' : 'Add To Cart'}
                                    </Button>
                                </div>
                            </div>
                            <Card className="bg-transparent border-0 product-card m-0 p-0">
                                <Link to={`/product?category=${encodeURIComponent(product.slug)}`} className='text-decoration-none'>
                                    <Text strong className='fw-bold fs-5'>{product.name}</Text>
                                </Link>
                                <br />
                                <Text>{product.description}</Text>
                                <div className="pricing mt-2">
                                    <Text delete className="fs-6">${product.price.toFixed(2)}</Text>
                                    <Text strong className="text-primary ml-2 ms-3 fs-5">${product.originalPrice.toFixed(2)}</Text>
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        </section>
    );
}
